<script lang="ts" setup>
import Slider from './Slider.vue';
import Map from './Map.vue';
</script>

<template>
  <section class="container all-post">
    <div class="all-post__title">
      <div class="all-post__title--sub">Where is DPOST?</div>
      <div class="all-post__title--main">디포스트 한 눈에 보기</div>
    </div>
    <Map />
    <Slider />
  </section>
</template>

<style lang="scss" scoped>
.all-post {
  @apply flex flex-col gap-7;
  @apply desktop:gap-20;

  &__title {
    @apply flex flex-col gap-6 text-center;
    @apply desktop:gap-8;

    &--sub {
      @apply text-xl font-bold text-primary;
      @apply desktop:text-2xl;
    }
    &--main {
      @apply text-3xl font-black;
      @apply desktop:text-5xl;
    }
  }
}
</style>
